/* eslint-disable no-underscore-dangle, no-mixed-operators */
const vanillaJsUtils = require('./vanillaJsUtils.es6');

/**
 * this is used to get popups or overlays to be positioned relative to a target element.
 * It also is aware of sticky (position:fixed) positions
 *
 * It works by positioning the element absolutely (or fixed if target is fixed)
 * at the smae top left coordinates at the target, then applying the custom
 * offsetsAndDimensions function to the default position calculation
 */

export default class DomPositionTracker {

  /**
   * @type {function} offsetsAndDimensions
   * @param element
   * @param target
   *
   * returns {
   *   top :number
   *   left: number
   *   width: number [optional]
   *   height: number [optional]
   * }
   */

  /**
   *
   * @param {HTMLElement} element this tracks the target position
   * @param {HTMLElement} target
   * @param {offsetsAndDimensions} [offsetsAndDimensions] custom
   * logic implemented on top of tracking
   */
  constructor(element, target, offsetsAndDimensions) {
    this._element = element;
    this._target = target;
    this._offsetsAndDimensions = offsetsAndDimensions;

    // we need to store these because we need this 'context'
    this._destroyBoundWithThis = this.destroy.bind(this);
    this._updatePositionBoundWithThis = this.updatePosition.bind(this);

    // since this is a global element next to the body we need to track the position of the target
    window.addEventListener('scroll', this._updatePositionBoundWithThis);
    window.addEventListener('resize', this._updatePositionBoundWithThis);
    this.updatePosition();
  }

  updatePosition() {

    // get default positions (top & left corner before applying custom logic ())
    const targetBoundingClientRect = this._target.getBoundingClientRect();

    // ie8 comp
    const scrollX = window.pageXOffset ? window.pageXOffset
      : window.document.documentElement.scrollLeft;
    const scrollY = window.pageYOffset ? window.pageYOffset
      : window.document.documentElement.scrollTop;

    const newTopPosition = targetBoundingClientRect.top + scrollY;
    const newLeftPosition = targetBoundingClientRect.left + scrollX;

    const customDimensions = this._offsetsAndDimensions(this._element, this._target);

    // assign positions to the callout
    if (vanillaJsUtils.isElementFixedOrChildOfFixedElement(this._target)) {
      this._element.style.position = 'fixed';
      this._element.style.left = `${newLeftPosition - scrollX + customDimensions.left}px`;
      this._element.style.top = `${newTopPosition - scrollY + customDimensions.top}px`;
    } else {
      this._element.style.position = 'absolute';
      this._element.style.left = `${newLeftPosition + customDimensions.left}px`;
      this._element.style.top = `${newTopPosition + customDimensions.top}px`;
    }
    if (customDimensions.width) {
      this._element.style.width = `${customDimensions.width}px`;
    }
    if (customDimensions.height) {
      this._element.style.height = `${customDimensions.height}px`;
    }
  }

  destroy() {
    setTimeout(function domPositionTrackerDestroy() { // eslint-disable-line prefer-arrow-callback
      window.removeEventListener('scroll', this._updatePositionBoundWithThis);
      window.removeEventListener('resize', this._updatePositionBoundWithThis);
      document.removeEventListener('mouseup', this._destroyBoundWithThis);
    }.bind(this), 50);
  }
}
